import { apiService } from "./apiService";

class AIService {
  async makeDetailedNotes(content) {
    try {
      const response = await apiService.post("/api/ai/make-notes", {
        content: content,
      });

      if (!response) {
        throw new Error("Failed to generate notes");
      }

      return {
        mainSummary: response.mainSummary || response,
        keyPoints: response.keyPoints || [],
      };
    } catch (error) {
      console.error("Error making detailed notes:", error);
      throw error;
    }
  }

  async summarize(content) {
    try {
      const response = await apiService.post("/api/ai/summarize", {
        content: content,
      });

      if (!response) {
        throw new Error("Failed to generate summary");
      }

      return {
        summary: response.summary || response,
        keyPoints: response.keyPoints || [],
      };
    } catch (error) {
      console.error("Error generating summary:", error);
      throw error;
    }
  }

  async chat(messages) {
    try {
      const response = await apiService.post("/api/ai/chat", {
        messages: messages,
      });

      if (!response) {
        throw new Error("Failed to get chat response");
      }

      return response;
    } catch (error) {
      console.error("Error in chat:", error);
      throw error;
    }
  }
}

export const aiService = new AIService();
